import { reportNonFatalError } from '@/app/error-handling'

const prefix = 'quiz.practice.inspiration'

function keyBase(score: number) {
  return prefix + `.score_${score}`;
}

function titleKey(score: number) {
  return keyBase(score) + '.title';
}

function messageKey(score: number) {
  return keyBase(score) + '.message';
}

const scoreMilestones = [20, 40, 60, 74, 89, 99, 100];

interface Item {
  title: string
  message: string
}

export function getPracticeQuizResultMessage(score: number): Item {

  for (const currentScore of scoreMilestones) {
    if (score <= currentScore) {
      return {
        title: titleKey(currentScore),
        message: messageKey(currentScore)
      }
    }
  }

  reportNonFatalError(`Message not found for score: ${score}`)

  return {
    title: titleKey(score),
    message: messageKey(score)
  }
}
